import React from 'react'
import { AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons';
import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu';
import { SalePlanningTask } from '@sales/data/planningTasks/PlanningTaskData';
import { usePlanningTaskCompleteAction, usePlanningTaskDeleteAction } from '@sales/data/planningTasks/PlanningTaskDataActions';
import AssignPlanningTaskDialog from '../../dialogs/AssignPlanningTaskDialog';

const PlanningTaskActionMenu = (props: { task: SalePlanningTask }) => {
    const completeTaskAction = usePlanningTaskCompleteAction();
    const deleteTaskAction = usePlanningTaskDeleteAction();

    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Task">
                <AssignPlanningTaskDialog.Button saleId={props.task.saleId} taskId={props.task.id} />
                <AgTechButton
                    text={props.task.isComplete ? "Reopen Task" : "Complete Task"}
                    icon={props.task.isComplete ? "fas fa-rotate-left" : "fas fa-check"}
                    action={e => e.actions.executeDataActionWithVisual(
                        completeTaskAction,
                        {
                            submittedEntity: { task: props.task, isComplete: !props.task.isComplete }
                        },
                        {
                            message: props.task.isComplete ? 'Reopening task...' : 'Completing task...',
                            delay: 300
                        }
                    )}
                />
                <AgTechButton
                    text="Delete Task"
                    icon="fas fa-times"
                    action={async e => {
                        await e.actions.executeDataActionInModal(deleteTaskAction, {
                            originalEntity: { task: props.task },
                            submittedEntity: { task: props.task }
                        });
                    }}
                />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
}

export default PlanningTaskActionMenu
